/** Keep STALE_PROCESSING_MS in sync with tradestation-server/services/aiChatJobService.js */
export const STALE_PROCESSING_MS = 4 * 60 * 1000;
/** Poll often enough to pick up streamed partials without waiting on Pusher. */
export const CHAT_POLL_MS = 500;
export const ACTIVE_SESSION_STORAGE_KEY = 'precisionai.activeSessionId';
export const INTERRUPTED_REPLY = 'This response was interrupted. Please send your message again.';

export function isProcessingStale(processingStartedAt, now = Date.now()) {
  if (!processingStartedAt) return true;
  const started = new Date(processingStartedAt).getTime();
  if (!Number.isFinite(started)) return true;
  return now - started >= STALE_PROCESSING_MS;
}

export function isSessionProcessing(session, now = Date.now()) {
  return session?.status === 'processing' && !isProcessingStale(session.processing_started_at, now);
}

export function readActiveSessionId() {
  try {
    return sessionStorage.getItem(ACTIVE_SESSION_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeActiveSessionId(id) {
  try {
    if (id == null || id === '') {
      sessionStorage.removeItem(ACTIVE_SESSION_STORAGE_KEY);
    } else {
      sessionStorage.setItem(ACTIVE_SESSION_STORAGE_KEY, String(id));
    }
  } catch {
    // Private mode can reject sessionStorage; the in-memory panel still works.
  }
}
